import api from '../../../services/service_pos'

export default {
  data () {
    return {
      bill_data: [],
      hostshift: '',
      search: '',
      currentPage: 1,
      items_perpage: 10,
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: ''
    }
  },
  created () {
    this.checkUser()
    if (sessionStorage.hostshift) {
      this.hostshift = JSON.parse(sessionStorage.hostshift)
    } else {
      this.$router.push('/')
    }
  },
  computed: {
    paginate: function () {
      this.totalItem = this.bill_data.length
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1)
      }
      var index = (this.currentPage - 1) * this.items_perpage
      return this.bill_data.slice(index, index + this.items_perpage)
    }
  },
  methods: {
    CheckSearch () {
      if (this.search === '') {
        this.onChange(1)
        this.getBillAll()
      }
    },
    itemRender (current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    onChange (pageNumber) {
      this.currentPage = pageNumber
    },
    getBillAll () {
      this.$store.commit('Loading')
      var obj = {
        'host_code': this.hostshift.host_code,
        'keyword': this.search,
        'shift_id': this.hostshift.id
      }
      api.billList(
        this.REST_URL,
        obj,
        this.header,
        result => {
          if (result.response === 'success') {
            this.bill_data = []
            result.data.forEach(val => {
              if (val['bill_type'] === 1) {
                this.bill_data.push(val)
              }
            })
          } else {
            this.$notification['warning']({
              message: 'เปิดการขายไม่ได้',
              description: result.message
            })
          }
          this.$store.commit('Loading')
          $('body').on('hidden.bs.modal', '.modal', function () {
            $(this).removeData('bs.modal')
          })
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    printPay (data) {
      $('#ToolModal').modal('hide')
      this.$store.commit('Loading')
      var obj = {
        'printer_port': this.hostshift.printer_port,
        'doc_no': data.doc_no
      }
      api.printPaybill(this.REST_URL,
        obj,
        this.header,
        result => {
          if (result.response === 'success') {
            this.$notification['success']({
              message: 'พิมพ์ใบแจ้งยอดสำเร็จ',
              description: result.message
            })
          } else {
            this.$notification['warning']({
              message: 'พิมพ์ใบแจ้งยอดไม่ได้',
              description: result.message
            })
          }
          $('body').on('hidden.bs.modal', '.modal', function () {
            $(this).removeData('bs.modal')
          })
          this.$store.commit('Loading')
        },
        error => {
          $('#ToolModal').modal('show')
          this.$store.commit('Loading')
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    printPDF (data) {
      this.$store.commit('Loading')
      api.billCreditDetail(this.REST_URL,
        this.header,
        { doc_no: data.doc_no },
        result => {
          if (result.response === 'success') {
            this.form_data = JSON.stringify(result.data)
            setTimeout(() => {
              this.$refs.printInvioce.submit()
              this.$store.commit('Loading')
              $('#ToolModal').modal('hide')
              $('body').on('hidden.bs.modal', '.modal', function () {
                $(this).removeData('bs.modal')
              })
            }, 1000)
          } else {
            this.$notification['warning']({
              message: 'พิมพ์ใบแจ้งยอดไม่ได้',
              description: result.message
            })
            $('body').on('hidden.bs.modal', '.modal', function () {
              $(this).removeData('bs.modal')
            })
            this.$store.commit('Loading')
          }
        },
        error => {
          $('#ToolModal').modal('show')
          this.$store.commit('Loading')
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        })
    }
  },
  mounted () {
    $('#ToolModal').on(
      'show.bs.modal',
      function () {
        this.search = ''
        this.getBillAll()
      }.bind(this)
    )
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/pos/bill_credit_list.js